import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Header from "./../../Header";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "../../ag-theme-intranet.css";
import "./feature.css";


class FeatureListing extends Component {
  constructor(props) {
    super(props);
    var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(localStorage.getItem("encdata"), 0)
      : "";

    this.state = {
      redirect: false,
      activePage: 1,
      item_count: '',
      userAuthKey: has_local_data ? localdata.user_key : "",
      apiUrl: this.decryptconfigdata("apiUrl"),
      userId: has_local_data ? localdata.user_id : "",
      user_Name: has_local_data ? localdata.user_name : "",

      form_name: '',
      waiting: '',
      error_message:'',
      success_message:'',
      errors: {},
      formData:{},
      pod:[],
      product:[],
      feature_template:[],
      selected_product_list:[],
      selected_pod_list:[],
      paginationPageSize:10,
      columns: [{
        headerName: "Feature",
        field: "feature",
        //autoHeight: true,
        suppressMenu: true, 
        sortable: true,
        tooltipField: 'feature', 
        filter: 'agTextColumnFilter',
        // cellRenderer: (row) => (
        //  `<a href="/feature/view/${row.data.feature}">${row.data.feature}</a>`
        // ),
        cellRenderer: (row) => (
        <a onClick={() => this.showEditFeature(row.data)} className = "ag-link">{row.data.feature}</a>
        ),
        
        floatingFilter: true,
        width: 250, 
      },
      {
        headerName: "Sub Feature",
        field: "sub_feature",
        suppressMenu: true, 
        sortable: true,
        //autoHeight: true,
        tooltipField: 'sub_feature', 
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        width: 250, 
      },
      {
        headerName: "Pod",
        field: "pod",
        sortable: true,
        suppressMenu: true, 
        //tooltipField: 'pod', 
        //autoHeight: true,
        filter: 'agTextColumnFilter',
       // cellClass: "cell-wrap-text",
        floatingFilter: true,
        autoHeight: true,
        cellRenderer: this.tagsGenerator,
        // width: 300, 
      },
      {
        headerName: "Product",
        field: "product",
        suppressMenu: true, 
        sortable: true,
        //autoHeight: true,
        //tooltipField: 'product', 
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        cellRenderer: this.tagsGenerator,
        // width: 250, 
      },
      {
        headerName: "App",
        field: "platforms",
        sortable: true,
        //autoHeight: true,
        suppressMenu: true, 
        //tooltipField: 'platforms', 
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        autoHeight: true,
        cellRenderer: this.tagsGenerator,
        // width: 250, 
      },
      {
        headerName: "Template",
        field: "feature_template",
        sortable: true,
        suppressMenu: true, 
        //tooltipField: 'pod', 
        //autoHeight: true,
        filter: 'agTextColumnFilter',
       // cellClass: "cell-wrap-text",
        floatingFilter: true,
        autoHeight: true,
        cellRenderer: this.tagsGenerator,
        // width: 300, 
      },
      {
        headerName: "Muvi6 R1",
        field: "muvi6_r1",
        sortable: true,
        suppressMenu: true,  
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        //width: 150, 
      },
      {
        headerName: "Feature Demo",
        field: "feature_demo",
        suppressMenu: true, 
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
        //width: 200, 
      },
      {
        headerName: "Specs",
        field: "specs",
        suppressMenu: true, 
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
        //width: 200, 
      },
      {
        headerName: "Marketing Briefs",
        field: "marketing_briefs",
        suppressMenu: true, 
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
       // width: 200, 
      },
      {
        headerName: "Help Article",
        field: "help_article",
        suppressMenu: true,
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
        //width: 200, 
      },
      {
        headerName: "Feature Page",
        field: "feature_page",
        suppressMenu: true, 
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
        //width: 200, 
      },
      {
        headerName: "Demo Video",
        field: "demo_video",
        suppressMenu: true, 
        flex: 1,
        sortable: true,
        autoHeight: true,
        cellRenderer: this.LinksGenerator,
        sortable: true,
        width: 200, 
      },
      // {
      //   headerName: "",
      //   field: "actions",
      //   cellClass: "center-align",
      //   pinned: 'right',
      //   width: 50,
        // cellRenderer: (row) => (

        //  // <a href='/feature/edit/'{row.data.id} target="_blank"><i class="fal fa-pencil cta"></i></a>
        //   <i class="fal fa-pencil cta"  onClick={() => this.showEditFeature(row.data)}></i>
        // )
      // }

    
    ],
    };
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
  }


  tagsGenerator(params)  {
    let links = '';
     let cellvalue = params.value;
 
     if (typeof cellvalue !== 'undefined' && cellvalue.length > 0) {
 
       const myArray = cellvalue.split(",");
 
       console.log("converterd", myArray);
       
       links = <ul className = "ul_top_hypers">{myArray.map((item, index) => (
       <li className="viewDemo" key = {index} ><span className="ListTags" key = {index} title={item}>{item}</span></li>))}</ul>
         
     }
  return links;
   }
 
   LinksGenerator(params)  {
    let links = '';
       let cellvalue = params.value;
 
       if (typeof cellvalue !== 'undefined' && cellvalue.length > 0) {
         
          links = <ul className = "ul_top_hypers">{cellvalue.map((item, index) => (<li className="viewDemo" key = {index} >
           <a href = {item.display_link} target = "_blank"><span class="ListTags" title={item.display_text}>{item.display_text}</span></a></li>))}</ul>
              
       }
 return links;
   }

  
  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }
  rawjsonparse(findresponse, flg) {
    return findresponse;
  }


  GetFeatureList() {
    fetch(this.state.apiUrl + '/AddFeature/getAllFeatures', {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(this.state),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        console.log("Dateaa", findresponse);
        this.setState({
          features: findresponse.data,
          totalRows: findresponse.count,
          pod: findresponse.pods,
          product: findresponse.products,
          feature_template: findresponse.feature_template,
        });
    });
}

  componentDidMount() {
    document.title = "Intranet | List Feature";
    if (!localStorage.getItem('userLogin')) {
      this.setState({ redirect: true });
    }

    this.GetFeatureList();
    
  }

 
  onPageSizeChanged = (event) => {
    this.setState({ paginationPageSize: event.target.value });
    this.gridApi.paginationSetPageSize(Number(event.target.value));
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
  };

  searchGrid = (event) => {
    const { name, value } = event.target;
    this.gridApi.setQuickFilter(value);
  };

  
  showEditFeature(data){

    let feature_id = data.id;
    window.location.href = "/feature/view/" + feature_id;

    // let selected_product = [];
    // let selected_pod = [];

    // let product_list = data.selected_product_list;
    // let pod_list = data.selected_pod_list;

    // product_list.forEach((element) => {
    //   selected_product.push(element.product_key);
    // });

    // pod_list.forEach((element) => {
    //   selected_pod.push(element.id);
    // });

    // this.setState({
    //   waiting:'',
    //   form_name:'Edit',
    //   errors: {},
    //   success_message:'',
    //   selected_product_list: data.selected_product_list,
    //   selected_pod_list: data.selected_pod_list,
    //   formData :{'id':data.id,'feature_page':data.feature_page,'help_article':data.help_article,'feature':data.feature,'product':selected_product,'pod':selected_pod}
    // });

    // console.log("Hello" + this.state.formData);

  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }

    return (

      <div>
        <Header brecum_name="ER" brecum_page="Features" />
        <div className="right_col feature_right_col">
          <div className="intranet_body">
            <div className="title mob hidden-sm">
              <span>Features</span>
            </div>
            <div className ="row m_t_10 m_b_10">
                <div className = 'col-md-2'>
                    <a className="btn btn-sky" href = "/feature/add">Add Feature</a>
                </div>
                <div className = 'col-md-5'></div>
                <div className = 'col-md-5'>
                    <div className="searchTicket emp_dept">
                        <input type="text" class="form-control" name="feature" id="customer" autoComplete="off" placeholder="Search by keyword"  onChange={this.searchGrid} /><button type="button"><i className="fa fa-search"></i></button>
                    </div>
                </div>
            </div>

            <div className="ag-theme-material" style={{height: '70vh'}}>
            <AgGridReact
                  rowData={this.state.features}
                  columnDefs={this.state.columns}
                  pagination={true}
                  resizable={true}
                  //suppressHorizontalScroll={true}
                  //fullWidthCellRenderer= {this.fullWidthCellRenderer}
                  paginationPageSize={this.state.paginationPageSize}
                  onGridReady={this.onGridReady}
              />
			      </div>
            <div className = "aggrid_custom_page">
                Page Size
                <select style={{borderColor:'#e6e2e2',fontSize:'13px',color:'#484848'}} onChange={(e) => this.onPageSizeChanged(e)}  value={this.state.paginationPageSize} >
                    <option value="10" selected={true}>
                    10
                    </option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default FeatureListing;


// WEBPACK FOOTER //
// ./src/components/feature/FeatureListing.js